import { type Pagination, createUserList } from 'models';
import { useQuery } from 'query';
import { getProgramsUsers } from '../services';
import type { ProgramsUsersListFilter } from '../types';
import { getProgramUsersKey } from './keys';

type P = {
  filter: ProgramsUsersListFilter;
  pagination: Omit<Pagination, 'position'>;
};

export const useProgramUsersQuery = ({ filter, pagination }: P) =>
  useQuery({
    async queryFn() {
      const response = await getProgramsUsers({
        config: {
          params: { limit: pagination.pageSize, search: filter.search },
        },
        routeParams: { id: filter.programId },
      });

      return {
        joinedCount: response.data.joined_count,
        users: response.data.users.map((user) => createUserList(user)),
      };
    },
    queryKey: getProgramUsersKey({ filter, pagination }),
  });
